<div
  class="flex flex-col bd-filter-options"
  [ngClass]="{ 'bd-horizontal': isHorizontal }"
>
  @for (filterOption of filterOptions; track filterOption.key) {
    <div
      class="bd-filter-item bd-checkbox-wrapper"
      [attr.data-id]="'filter-item-' + filterOption.key"
    >
      <div>
        <label
          class="flex flex-1 items-center gap-2 w-fit"
          [for]="'filter-item-checkbox-' + filterOption.key"
        >
          <div
            [attr.data-id]="'filter-item-icon-' + filterOption.key"
            class="bd-filter-item-icon"
          >
            <i class="{{ filterOption.icon }}"></i>
          </div>
          @let label =
            (filterOption | translateDisplayText: 'label' | async) ?? '';
          <div
            [attr.data-id]="'filter-item-label-' + filterOption.key"
            class="overflow-hidden whitespace-nowrap text-ellipsis max-w-[172px]"
          >
            {{ label }}
          </div>
        </label>
        <p-checkbox
          [inputId]="'filter-item-checkbox-' + filterOption.key"
          [attr.data-id]="'filter-item-checkbox-' + filterOption.key"
          [(ngModel)]="filterOption.checked"
          [binary]="true"
          (onChange)="updateFilterOptions($event, filterOption)"
          checkboxIcon="ui-check"
        >
        </p-checkbox>
      </div>
    </div>
  }
</div>
